import React from 'react';
import ReportFrame from '../ReportFrame';

export default class LineItemFeeRevenueByType extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ReportType']}
          reportName='Revenue Metrics - Line Item Fee Revenue by Type'
          reportParams={reportParams}
          id='lineitemfeerevenuebytype'
          name='lineitemfeerevenuebytype'
          title='Line Item Fee Revenue by Type'
        />
      </div>
    );
  }
}
